var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,0 H18 C19,0 20,1 20,2 V12 C20,13 19,14 18,14 H2 C1,14 0,13 0,12 V2 C0,1 1,0 2,0 Z M1,2 V12 C1,12.5 1.5,13 2,13 H18 C18.5,13 19,12.5 19,12 V2 C19,1.5 18.5,1 18,1 H2 C1.5,1 1,1.5 1,2 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6,
    y: 15,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3,
    y: 16,
    width: 14,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComputer);
export default __webpack_public_path__ + "static/media/ic_computer.4db2503d6179dc840b2a71147e28caf8.svg";
export { ForwardRef as ReactComponent };